import { api } from "../rtk";
import { ENDPOINTS } from "../url";

export const blogsApi = api.injectEndpoints({
    endpoints: (builder) => ({
        uploadBlogImages: builder.mutation({
            query: (data) => ({
                url: ENDPOINTS.UPLOAD_BLOG_IMAGES,
                method: 'POST',
                body: data,
            }),
        }),
        addBlog: builder.mutation({
            query: (data) => ({
                url: ENDPOINTS.BLOGS,
                method: 'POST',
                body: data,
            }),
        }),
        getBlogs: builder.query({
            query: (params) => ({
                url: ENDPOINTS.BLOGS,
                method: 'GET',
                params,
            }),
            providesTags: ['Blogs'],
        }),
        getBlogById: builder.query({
            query: (id) => ({
                url: `${ENDPOINTS.BLOGS}/${id}`,
                method: 'GET',
            }),
            providesTags: (result, error, id) => [{ type: 'Blogs', id }],
        }),
        deleteBlog: builder.mutation({
            query: (id) => ({
                url: `${ENDPOINTS.BLOGS}/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Blogs'],
        }),
        updateBlog: builder.mutation({
            query: ({ id, ...data }) => ({
                url: `${ENDPOINTS.BLOGS}/${id}`,
                method: 'PUT',
                body: data,
            }),
            invalidatesTags: ['Blogs'],
        }),
    }),
    overrideExisting: false,
});

export const { useUploadBlogImagesMutation, useAddBlogMutation, useGetBlogsQuery, useDeleteBlogMutation, useGetBlogByIdQuery, useUpdateBlogMutation } = blogsApi;
